import axios from 'axios'
import { Modal, message } from 'antd'

const DeleteJobFairApplication = (props) => {
    const { id, name } = props.data

    const handleOk = () => {
        axios.post('/admin/job_fair/delete', {
            application_id: id
        })
            .then(function (response) {
                if (response.errcode === 0) {
                    message.success('删除成功！')
                    props.isCancel()
                    props.getApplicationData()
                }
            })
            .catch(function (error) {
                console.error('请求失败，错误信息为：', error)
            })
    }

    return (
        <Modal
            title="删除宣讲会预约申请"
            open={props.isOpen}
            onOk={handleOk}
            onCancel={props.isCancel}
            cancelText="取消"
            okType='danger'
            okText='删除'>

            <p>正在将
                <span style={{ color: '#005dff' }}>《{name}》</span>
                的宣讲会预约申请从列表中移除，此操作不可逆，是否确认删除？
            </p>
        </Modal>
    )
}

export default DeleteJobFairApplication
